import * as React from 'react'
import styled, { keyframes }  from "styled-components";

const loadText = `
_start:\n
    ; initialize counters to 0 mov category_1_count, 0 mov category_2_count, 0 mov category_3_count, 0 mov category_4_count, 0\n
    ; sort star data into categories\n
    mov ecx, num_stars ; set loop counter\n
    mov esi, star_data ; set source pointer\n

.load vector offset package
  ; system network connection - stable
  ; ping success
  ; telemetry 
.loop:\n
    mov ax, [esi] ; load star brightness from memory\n
    cmp ax, 7500 ; compare to threshold for category 1\n
    jb .category_2 ; jump if in category 2\n
    cmp ax, 15000 ; compare to threshold for category 2\n
    jb .category_3 ; jump if in category 3\n
    cmp ax, 25000 ; compare to threshold for category 4\n
    jae .category_4 ; jump if in category 4\

!ERROR! ILLEGAL KEY DETECTED - YOUR CORPORATE LICENSE IS REVOKED !ERROR!
LOADING D-crpyt-getoutofjailfree.exe
......
......
......
......
......
......
`

const loadText2 = `
IT WORKED
CONGRATULATIONS, YOU BROKE THE LAW
I'm proud of you :)

.category_1:\n
    ; increment category 1 count inc category_1_count jmp .next_star\n
.category_2: ; increment category 2 count inc category_2_count jmp .next_star\n
.category_3:  ; increment category 3 count  inc category_3_count
    jmp .next_star
.category_4:
    ; increment category 4 count
    inc category_4_count
    jmp .next_star\n

.next_star:
    add esi, 2 ; increment source pointer
    loop .loop ; loop back to start until all stars have been processed

    ; output categories to console
    mov eax, 4 ; system call for write
    mov ebx, 1 ; file descriptor for stdout
    mov ecx, category_1 ; pointer to category 1 string
    mov edx, category_1_count ; length of category 1 count
    int 0x80 ; call kernel to write category 1 to console
    mov eax, 4 ; system call for write
    mov ebx, 1 ; file descriptor for stdout
    mov ecx, category_2 ; pointer to category 2 string
    mov edx, category_2_count ; length of category 2 count
    int 0x80 ; call kernel to write category 2 to console
    mov eax, 4 ; system call for write
    mov ebx, 1 ; file descriptor for stdout
    mov ecx, category_3 ; pointer to category 3 string
    mov edx, category_3_count ; length of category 3 count
    int 0x
`

const glitch = keyframes`
  0% {
    text-shadow: -0.03em -0.04em 0 #39ff1499,
      0.025em 0.04em 0 #39ff1430;
  }
  15% {
    text-shadow: -0.03em -0.04em 0 #39ff1499,
      0.025em 0.04em 0 #39ff1430;
  }
  16% {
    text-shadow: 0.025em 0.035em 0 #39ff1499,
      -0.05em -0.05em 0 #39ff1430;
  }
  49% {
    text-shadow:  0.025em 0.035em 0 #39ff1499,
      -0.05em -0.05em 0 #39ff1430;
  }
  50% {
    text-shadow: 0.03em 0 0 #39ff1499,
      0 -0.04em 0 #39ff1430;
  }
  99% {
    text-shadow: 0.03em 0 0 #39ff1499,
      0 -0.04em 0 #39ff1430;
  }
  100% {
    text-shadow:  -0.025em -0.04em 0 #39ff1499,
      -0.04em -0.025em 0 #39ff1430;
  }
`

const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
     }
`

const reveal = keyframes`
    0% {
        height: 10px;
    }
    10% {
        height: 20px;
    }
    50% {
        height: 50px;
    }
    100% {
        height: 350px;
    }
`

const fastreveal = keyframes`
    0% {
        height: 0px;
    }
    5% {
        height: 50px;
    }
    100% {
        height: 350px;
    }
`

const LoadContainer = styled.div`
  width: 100vw;
  height: 100vh;
  text-align: center;
  animation: ${fadeIn} ease .75s reverse;
  animation-delay: 1.75s;
`

const StyledMessage = styled.h1`
  color: ${(props) => props.theme.primaryColor};
  margin:  0 auto;
  margin-top: 15%;
  animation: ${glitch} linear 1s infinite;
  font-size: 2em;
`
const ScrollText = styled.div`
  color: ${(props) => props.theme.hoverColor};
  margin: 2em auto;
  width: 40%;
  height: 0px;
  text-align: left;
  overflow: hidden;
  font-size: .25em;
  white-space: pre;
  animation: ${reveal} linear .8s forwards;
  animation-delay: ${(props) => props.delay}
`

const FastText = styled.div`
  color: ${(props) => props.theme.hoverColor};
  margin: 2em auto;
  width: 40%;
  height: 0px;
  text-align: left;
  overflow: hidden;
  font-size: .25em;
  white-space: pre;
  animation: ${fastreveal} linear .8s forwards, ${glitch} ease .5s infinite;
  animation-delay: ${(props) => props.delay}
`

const Loading = () => {
  return (
    <LoadContainer>
      <StyledMessage>INITIALIZING PLANETARY SENSORS</StyledMessage>
      <ScrollText>{loadText}</ScrollText>
      <ScrollText delay={'1.2s'}>{loadText2}</ScrollText>
    </LoadContainer>
  )
}

export default Loading
